import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CadastroService } from '../../../../services/cadastro.service';
import { Cargo } from '../../../../models/cadastro.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorModel } from '../../../../models/error.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cargos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './cargos.component.html',
  styleUrls: ['./cargos.component.css']
})
export class CargosComponent implements OnInit {
  cargos: Cargo[] = [];
  filteredCargos: Cargo[] = [];
  paginatedCargos: Cargo[] = [];

  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  searchTerm = '';

  private cdr = inject(ChangeDetectorRef);

  constructor(
    private cadastroService: CadastroService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadCargos();
  }

  loadCargos(): void {
    this.cadastroService.getCargos().subscribe({
      next: (data) => {
        this.cargos = data;
        this.filteredCargos = data;
        this.totalPages = Math.max(1, Math.ceil(this.filteredCargos.length / this.itemsPerPage));
        this.setPage(1);
        this.cdr.detectChanges();
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar cargos.');
      }
    });
  }

  search(): void {
    this.filteredCargos = this.cargos.filter(cargo =>
      cargo.descricao.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.totalPages = Math.max(1, Math.ceil(this.filteredCargos.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredCargos.length);
    this.paginatedCargos = this.filteredCargos.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from(
      { length: (this.endPage - this.startPage) + 1 },
      (_, i) => this.startPage + i
    );
  }

  novoCargo(): void {
    this.router.navigate(['/home', 'cadastro-cargo-manutencao']);
  }

  editarCargo(id: number): void {
    this.router.navigate(['/home', 'cadastro-cargo-manutencao', id]);
  }

  deleteCargo(id: number): void {
    this.cadastroService.deleteCargo(id).subscribe({
      next: () => {
        this.loadCargos();
        this.toastr.success('Cargo excluído com sucesso!');
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro.message);
      }
    });
  }
}
